import { render, staticRenderFns } from "./businessPowerManange.vue?vue&type=template&id=710068a6&scoped=true&"
import script from "./businessPowerManange.vue?vue&type=script&lang=js&"
export * from "./businessPowerManange.vue?vue&type=script&lang=js&"
import style0 from "./businessPowerManange.vue?vue&type=style&index=0&id=710068a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710068a6",
  null
  
)

export default component.exports